import React, { Component } from "react";

import { userService } from "../../Services/UserService.js";

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';
import GroupIcon from '@material-ui/icons/Group';

import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AddIcon from '@material-ui/icons/Add';

class RaterSelector extends Component {
	constructor(props) {
        super(props);
		this.state= {
			userList: this.props.raters,
			canvis: {}
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleSend = this.handleSend.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.orderUsers = this.orderUsers.bind(this);
		this.filterUsers = this.filterUsers.bind(this);
    }
	
	componentDidMount() {
		//this.setState({customerList: this.props.managedCustomers});
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.raters !== this.props.raters) {
			this.setState({ userList: nextProps.raters });
		}
	}
	
	handleOpen(){
	};
	
	handleClose(){
		//this.setState({dialogOpen: false});
		this.props.dialogClose();
	};
	
	handleChange(e) {
		let list = this.state.userList;
		let canvis = this.state.canvis;
		
		let def=e.target.value.split("_");
		let id=Number(def[1]);

		if(e.target.checked){
			list.push({id:0, user:this.props.users[id]});
			canvis[id]=0;
			//list[id]=this.props.users[id];
		}else{
			list.forEach(element => {if(element.user.id === id){element.id>0 ? canvis[id]=element.id : canvis[id]=-1;}});
			list = list.filter(element => element.user.id != id);
			//delete list[id];
		}
		this.setState({userList: list, canvis: canvis});
	}
	
	orderUsers(a, b){
		return a.username.localeCompare(b.username);
	}
	
	filterUsers(user){
		//console.log(user);
		//return user.username.length>1 && user.role=="TRANSLATOR";
		return user.hasOwnProperty('lp') && user.lp.includes(this.props.currentLang);
	}
	
	handleSend(e){
		//this.props.setManagedCustomers(this.state.customerList.reduce((acc, cur, idx) => acc + (idx>0 ? ",":"") + cur.id, ""));
		this.props.updateRaters(this.props.currentLang, this.state.canvis);
		this.setState({ canvis: {} });
	};
	
	render() {
		//console.log("RaterSelector");
		//console.log(this.props);
		//console.log(this.state);
		let content = [];
		//let content = "SELECTOR..."+this.props.currentLang;
		if(this.props.users){
			Object.values(this.props.users).filter(this.filterUsers).sort(this.orderUsers).forEach(element => { content.push(<div><FormControlLabel 
																		control={
																			<Checkbox
																				defaultChecked={this.state.userList.reduce((acc, cur) => {return acc || cur.user.id==element.id;}, false)}
																				value={"user_"+element.id}
																				color="primary"
																				onChange={this.handleChange}
																			/>
																		}
																		label={element.username}
																	/></div>);
													});
		}
		return (
			<Dialog open={this.props.dialogOpen} onClose={this.handleClose} fullWidth={true} maxWidth = {'md'}>
				<DialogTitle>Raters:</DialogTitle>
				<DialogContent dividers>
					<DialogContentText>
						{content}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleSend} color="primary">
					SAVE
					</Button>
				</DialogActions>
			</Dialog>
		);
		
  }
};

export default RaterSelector;